import React from "react";
import { useTranslation } from "react-i18next";

const TabsContent = ({
  isContentFuelOpen,
  isContentMaintenanceOpen,
  openContentFuel,
  openContentMaintenance,
}) => {
  const { t } = useTranslation();

  return (
    <div className="x_content">
      <div className="x_content">
        <ul className="nav nav-tabs bar_tabs" id="myTab" role="tablist">
          <li className={`nav-item ${isContentMaintenanceOpen && "active"}`}>
            <a
              className="nav-link"
              aria-selected="false"
              onClick={openContentMaintenance}
            >
              {t("Manutenção")}
            </a>
          </li>
          <li className={`nav-item ${isContentFuelOpen && "active"}`}>
            <a aria-selected="false" onClick={openContentFuel}>
              {t("Combustível")}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TabsContent;
